import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './pages/App';
import 'bootstrap/dist/css/bootstrap.min.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(fas, fab, far); 

ReactDOM.render(<App />, document.getElementById('root'));
